enum STATUS {
  OK = 'OK',
  FAILED = 'FAILED',
}

export default STATUS;
